import { useRouterState } from '@tanstack/react-router';

import { DemoModeBanner } from '~features/demo-mode/ui/demo-mode-banner';
import { TopNavBar } from '~features/new-dashboard/ui/navbar';

/** Routes under `/_auth` that must not show the operational studio nav. */
const HIDE_OPERATIONAL_NAV_PREFIXES = ['/set-password'] as const;

export const shouldShowOperationalNav = (pathname: string) =>
  !HIDE_OPERATIONAL_NAV_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

/**
 * Shared sticky TopNavBar + demo banner for all signed-in operational pages
 * (dashboard, layout pages, calendars, etc.). Does not mount dashboard metrics.
 */
export const OperationalNavChrome = () => {
  const pathname = useRouterState({
    select: (s) => s.location.pathname,
  });

  if (!shouldShowOperationalNav(pathname)) {
    return null;
  }

  return (
    <>
      <TopNavBar />
      <DemoModeBanner />
    </>
  );
};
